import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M4.42105 10.5791H10.5789H13.4211H19.5789C19.9558 10.5791 20.3173 10.7288 20.5838 10.9953C20.8503 11.2618 21 11.6233 21 12.0002C21 12.377 20.8503 12.7385 20.5838 13.005C20.3173 13.2715 19.9558 13.4212 19.5789 13.4212H13.4211H10.5789H4.42105C4.04417 13.4212 3.68272 13.2715 3.41622 13.005C3.14972 12.7385 3 12.377 3 12.0002C3 11.6233 3.14972 11.2618 3.41622 10.9953C3.68272 10.7288 4.04417 10.5791 4.42105 10.5791Z' />
        </SvgIcon>
    );
});
